export * from "./getTenantId";
